module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Направить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Номер договора",
      "hint": "",
      "rules": [function (v) { return !!v || 'номер должен быть указан'; }],
      "clearable": ""
    },
    model: {
      value: (_vm.agreementNumber),
      callback: function($$v) {
        _vm.agreementNumber = $$v
      },
      expression: "agreementNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Срок действия по",
      "rules": [],
      "hint": ""
    },
    model: {
      value: (_vm.item.expiryTime),
      callback: function($$v) {
        _vm.$set(_vm.item, "expiryTime", $$v)
      },
      expression: "item.expiryTime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Вы являетесь",
      "hint": "",
      "clearable": "",
      "rules": [function (v) { return !!v || 'например: Стороной 1'; }]
    },
    model: {
      value: (_vm.clientRole),
      callback: function($$v) {
        _vm.clientRole = $$v
      },
      expression: "clientRole"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Партнер является",
      "rules": [function (v) { return !!v || 'например: Стороной 2'; }],
      "hint": "",
      "clearable": ""
    },
    model: {
      value: (_vm.partnerRole),
      callback: function($$v) {
        _vm.partnerRole = $$v
      },
      expression: "partnerRole"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Ссылка на документ",
      "clearable": "",
      "hint": "",
      "rules": [function (v) { return !!v || 'cсылка должна быть указана'; }]
    },
    on: {
      "click:prepend": _vm.dialogOpen
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f59d3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/PostOfferForm.vue
// module id = 1202
// module chunks = 1